import * as jwtDecode from "jwt-decode";

export interface AuthUser {
  token: string;
  email: string;
  exp: number;
  iat: number;
  id: string;
  name: string;
  scopes?: Array<string> | null;
}

export default class Auth {
  user: AuthUser | null;
  token: string | null;
  onUserChange: (newUser: AuthUser | null) => void;
  constructor() {
    this.decodeToken();
    window.addEventListener(
      "storage",
      e => e.key === "token" && this.decodeToken()
    );
  }

  userChanged() {
    if (this.onUserChange) {
      this.onUserChange(this.getUser());
    }
  }

  setToken(token: string) {
    localStorage.setItem("token", token);
    this.decodeToken();
    this.userChanged();
  }

  decodeToken() {
    try {
      this.token = localStorage.getItem("token") || "";
      this.user = jwtDecode(this.token);
      if (this.user) {
        this.user.token = this.token;
      }
      this.userChanged();
    } catch (e) {
      this.logout();
    }
  }

  logout() {
    this.user = null;
    this.token = null;
    localStorage.setItem("token", "");
    this.userChanged();
  }

  isAuthenticated(): boolean {
    // Check whether the current time is past the
    // access token's expiry time
    if (!this.user) {
      return false;
    }
    return new Date().getTime() < this.user.exp * 1000;
  }

  hasScope(scope: string): boolean {
    if (this.user && this.user.scopes) {
      return this.user.scopes.some(sc => sc === scope);
    }
    return false;
  }

  getUser() {
    return this.user;
  }
}



// WEBPACK FOOTER //
// ./src/services/Auth.ts